<template>
    <b-modal
        :title="$t('createShipment.aes.aesHeader') + getTitle"
        :ref="_uid"
        @ok="handleOk"
        @cancel="cancel"
        size="xl"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true"
    >
        <form ref="form" @submit.stop.prevent="handleOk">
            <b-form-group>
                <p>{{$t('createShipment.aes.aesInformation1')}}</p>
                <p>{{$t('createShipment.aes.aesInformation2')}}</p>

                <div
                    v-for="(commodity, index) in customsAmount.commodities"
                    v-bind:key="index"
                >
                    <aes-line
                        @add-aes-line="$emit('add-aes-line', $event)"
                        @remove-aes-line="$emit('remove-aes-line', index)"
                        :index="index"
                        :commodity="commodity"
                        :currencyCode="customsAmount.currencyCode"
                        :v="v"
                    ></aes-line>
                </div>
            </b-form-group>
        </form>

        <b-row>
            <b-col
                v-if="invalidTotalWeight"
                class="validation-error"
            >{{$t('createShipment.aes.weightValidationError', { totalCommodityWeight: getTotalCommodityWeight, totalWeight: totalWeight }) }}</b-col>
        </b-row>

        <template v-slot:modal-footer="{ ok }">
            <b-form-group class="mr-3" style="min-width: 15%">
                <b-row>
                    <b-col>{{$t('createShipment.aes.customs')}}{{customsAmount.amount}} {{customsAmount.currencyCode}}</b-col>
                </b-row>
                <b-row>
                    <b-col>{{$t('createShipment.aes.totalPrice')}}{{getTotalPrice}} {{customsAmount.currencyCode}}</b-col>
                </b-row>
                <b-row>
                    <b-col
                        v-if="invalidTotalPrice"
                        class="validation-error"
                    >{{$t('createShipment.aes.customsValidationError')}}</b-col>
                </b-row>
            </b-form-group>

            <b-button
                @click="cancel()"
                variant="secondary"
            >{{ $t('core.cancel') }}</b-button>

            <b-button @click="ok()" variant="primary">{{ $t('core.book') }}</b-button>
        </template>
    </b-modal>
</template>
<script>
  import AesLine from './aesLine.vue';
  export default {
      data() {
          return {
              invalidTotalPrice: false,
              invalidTotalWeight: false,
              selectedProduct: null,
          };
      },

      props: {
          customsAmount: { type: Object, required: true },
          v: { required: true },
          totalWeight: { required: true },
      },

      components: {
          AesLine,
      },

      computed: {
          getTotalPrice() {
              let totalPrice = 0;

              this.customsAmount.commodities.forEach((element) => {
                  totalPrice += element.quantity * element.unitPrice.amount;
              });

              return totalPrice;
          },

          getTotalCommodityWeight() {
              let totalCommodityWeight = 0;

              this.customsAmount.commodities.forEach((element) => {
                  totalCommodityWeight += element.quantity * element.unitWeight;
              });

              return totalCommodityWeight;
          },

          getTitle() {
              return this.selectedProduct !== null && this.selectedProduct !== undefined
                  ? ' - ' + this.selectedProduct.salesProductName
                  : '';
          },
      },

      beforeDestroy() {
          this.customsAmount.commodities = [];
      },

      methods: {
          handleOk(bvModalEvt) {
              bvModalEvt.preventDefault();
              this.confirm();
          },

          hasValidationError() {
              let hasError = false;

              if (!this.isTotalPriceValid()) {
                  this.invalidTotalPrice = true;
                  hasError = true;
              } else {
                  this.invalidTotalWeight = false;
              }

              if (!this.isTotalWeightValid()) {
                  this.invalidTotalWeight = true;
                  hasError = true;
              } else {
                  this.invalidTotalWeight = false;
              }

              return hasError;
          },

          confirm() {
              this.v.shipment.customsAmount.commodities.$touch();

              if (this.hasValidationError()) {
                  return;
              }

              if (this.v.shipment.customsAmount.commodities.$anyError) {
                  return;
              }

              this.$emit('create-shipment', this.selectedProduct);

              this.$nextTick(() => {
                  this.$refs[this._uid].hide();
              });
          },

          isTotalPriceValid() {
              let isValid = this.getTotalPrice === this.customsAmount.amount;
              return isValid;
          },

          isTotalWeightValid() {
              let isValid = this.totalWeight >= this.getTotalCommodityWeight;

              return isValid;
          },

          show(selectedProduct) {
              this.selectedProduct = selectedProduct;

              this.$refs[this._uid].show();

              if (
                  this.customsAmount.commodities == null ||
                  this.customsAmount.commodities.length == 0
              ) {
                  this.customsAmount.commodities = [
                      {
                          description: '',
                          countryOfManufacture: 'US',
                          harmonizedCode: '',
                          quantity: 1,
                          unitWeight: 0,
                          unitPrice: {
                              amount: 0,
                              currencyCode: this.customsAmount.currencyCode,
                          },
                      },
                  ];
              }
          },

          cancel() {
              this.$refs[this._uid].hide();

              this.customsAmount.commodities = [];

              this.v.shipment.customsAmount.commodities.$reset();
          },
      },
  };
</script>

<style></style>
